import type { Technician } from '../types';

export type DayStatus = 'work' | 'rest' | 'vacation' | 'star';

export const getDayStatus = (date: Date, tech: Technician): DayStatus => {
    // Check for manual overrides
    let dateKey = '';
    try {
        if (date && typeof date.toISOString === 'function') {
            dateKey = date.toISOString().split('T')[0];
        } else {
            // Try to handle if it's a string or other, or just fail safely
            if (date) {
                const d = new Date(date);
                if (!isNaN(d.getTime())) {
                    dateKey = d.toISOString().split('T')[0];
                }
            }
        }
    } catch (e) {
        console.warn('Invalid date passed to getDayStatus', date);
        return 'rest';
    }

    if (dateKey && tech.overrides && dateKey in tech.overrides) {
        return tech.overrides[dateKey] as DayStatus;
    }

    // Default is always rest since we are in manual mode
    return 'rest';
};

export const isWorkDay = (date: Date, nurse: Technician): boolean => {
    const status = getDayStatus(date, nurse);
    return status === 'work' || status === 'star';
};

export const getWorkDaysCount = (days: Date[], nurse: Technician): number => {
    return days.filter(day => isWorkDay(day, nurse)).length;
};

export const getAnnualStats = (year: number, nurse: Technician) => {
    const startOfYear = new Date(year, 0, 1);
    const endOfYear = new Date(year, 11, 31);

    // Create an array of all days in the year
    const days: Date[] = [];
    const current = startOfYear;
    while (current <= endOfYear) {
        days.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const totalScheduled = days.filter(d => getDayStatus(d, nurse) === 'work').length;

    // Count specific star days
    const totalStars = days.filter(d => getDayStatus(d, nurse) === 'star').length;

    // Remaining (future 'work' days only? or both? Let's assume remaining work load)
    // If 'star' is not in total, maybe remaining should also not count future stars?
    // Let's keep remaining as "days where nurse is physically present" for now, or match totalScheduled logic?
    // User said "nuits etoiles pas comptabilisé dans le compteur".
    // So remaining should probably also be just 'work'.
    const remaining = days.filter(d => d >= today && getDayStatus(d, nurse) === 'work').length;

    return { totalScheduled, remaining, totalStars };
};
